import { hotSearch } from '@/mocks/news';
import SectionHeading from '@/pages/home/components/SectionHeading';

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-secondary-600' },
  flat: { icon: 'ri-subtract-line', cls: 'text-foreground-400' },
};

export default function HotRankSection() {
  return (
    <section id="hot" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-16">
          <SectionHeading
            id="hot"
            kicker="热搜榜"
            title="今日热搜前十条"
            desc="热度按站内讨论量排序，黑料网1今日头条与快讯的爆点基本都会先在这里冒头。"
            actionHref="#topic"
            actionLabel="看专题合集"
          />

          <ol className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-10">
            {hotSearch.map((item) => {
              const trend = trendIcon[item.trend];
              const isTop = item.rank <= 3;
              return (
                <li key={item.rank} className="border-b border-background-200">
                  <a href="#hot" className="flex items-center gap-4 py-3.5 cursor-pointer group">
                    <span
                      className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md font-heading text-sm font-bold ${
                        isTop
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-50 text-foreground-500 border border-background-200'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex-1 text-sm md:text-[15px] text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    <span className="shrink-0 flex items-center gap-1 text-xs text-foreground-500 tabular-nums">
                      <i className={`${trend.icon} ${trend.cls}`} aria-hidden="true"></i>
                      {item.heat}
                    </span>
                  </a>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}